<template>
    <div>
    </div>
</template>

<script setup>
import { useFromExternal } from '@/hooks/useGoExternal'
useFromExternal()
</script>